export default __webpack_public_path__ + "static/media/AdobeStock_52669562.0718291d.jpg";